import React, { useState } from 'react'

import { Box, Button, Paper } from '@material-ui/core'

import { AlertDialog, Card } from 'components'
import { NcActionItem } from './components'

import helpers from 'helpers'
import * as service from 'service'

import useSnackbar from 'hooks/useSnackbar'

import useStyles from './styles'
import theme from 'theme'

const EMPTY_ACTION = {
  originId: null,
  correctiveAction: '',
  responsibleId: null,
  deadline: null,
  immediateAction: '',
  preventiveAction: '',
  effectivenessVerification: '',
  verificationDate: null,
  provenEffectiveness: false,
}

const NcActionsForm = ({
  monitoringManagementNcId,
  fields,
  append,
  remove,
  isDisabled,
  responseUsers,
  refresh,
  setLoading,
}) => {
  const [indexToDestroy, setIndexToDestroy] = useState(null)
  const [actionToDestroy, setActionToDestroy] = useState(null)
  const [openDestroyModal, setOpenDestroyModal] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const handleOpenDestroyModal = (field, index) => {
    if (!field.originId) {
      remove(index)
      return
    }
    setActionToDestroy(field)
    setIndexToDestroy(index)
    setOpenDestroyModal(true)
  }

  const handleCloseDestroyModal = () => {
    setOpenDestroyModal(false)
    setActionToDestroy(null)
    setIndexToDestroy(null)
  }

  const handleConfirmRemove = async () => {
    setLoading(true)
    try {
      await service.dponet.monitoringManagementNcActions.destroy({
        monitoringManagementNcId,
        monitoringManagementNcActionId: actionToDestroy.originId,
      })

      snackbar.open({
        message: 'Ação corretiva removida com sucesso.',
        variant: 'success',
      })

      remove(indexToDestroy)
      refresh()
    } catch (err) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(err?.response?.data?.error) ||
          'Erro ao remover ação corretiva.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
      handleCloseDestroyModal()
    }
  }

  return (
    <Card title="Ações Corretivas">
      <Box display="flex" flexDirection="column" gridGap={theme.spacing(3)}>
        {fields.map((field, index) => (
          <Paper
            key={field.id}
            variant="outlined"
            className={classes.actionItemContainer}
          >
            <NcActionItem
              field={field}
              componentIndex={index}
              responseUsers={responseUsers}
              isDisabled={isDisabled}
              onRemove={() => handleOpenDestroyModal(field, index)}
            />
          </Paper>
        ))}
      </Box>

      {!isDisabled && (
        <Box
          mt={fields.length > 0 ? 1 : 0}
          display="flex"
          justifyContent="flex-end"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => append(EMPTY_ACTION)}
          >
            Adicionar ação corretiva
          </Button>
        </Box>
      )}

      <AlertDialog
        open={openDestroyModal}
        onClose={handleCloseDestroyModal}
        variant="standard"
        severity="warning"
        content="Tem certeza de que deseja excluir esta ação corretiva? Essa ação não poderá ser desfeita!"
        dialogActions={
          <>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCloseDestroyModal}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmRemove}
            >
              Excluir
            </Button>
          </>
        }
      />
    </Card>
  )
}

export default NcActionsForm
